import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 146889 81115"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#1c1b17;stroke-width:2107.53}.fil0{fill:#1c1b17}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970275340976">
        <path
          d="M33525 1054h47179L48537 40557l32167 39504H33525L1359 40557z"
          className="fill stroke1"
          style={{
            strokeWidth: 2107.53,
          }}
        />
        <path
          d="M97452 1054h15398L80683 40557l32167 39504H97452L65283 40557z"
                    className="fill stroke1"
          style={{
            strokeWidth: 2107.53,
          }}

        />
        <path
          d="M129272 1054h15400l-32168 39503 32168 39504h-15400L97105 40557z"
                    className="fill stroke1"
          style={{
            strokeWidth: 2107.53,
          }}

        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
